import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import moment from "moment/moment";
import Datetime from "react-datetime";

class AdditionalInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {error: {}};
        this.onChange = this.onChange.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    componentWillMount() {
        this.setState({additionalInformation: this.props.additionalInformation});
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.error !== nextProps.error) {
            this.setState({error: nextProps.error});
        }

        if (nextProps.manual) {
            this.setState({additionalInformation: nextProps.additionalInformation, error: {}});
            this.props.isManual(false);
            this.props.errorListener({});
        }
    }

    onChange(e) {
        let additionalInformation = deepCopyObject(this.state.additionalInformation);
        additionalInformation[e.target.name] = e.target.value;
        this.props.listener(additionalInformation);
        this.setState({additionalInformation});
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
        this.props.errorListener(error);
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    render() {
        let additionalInformation = deepCopyObject(this.state.additionalInformation);
        return(
            <div className="row">
                <div className="col-sm-12 row">
                    {this.props.invoiceTypeCode !== 'SARJ' && this.props.invoiceTypeCode !== 'SARJANLIK' &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">IMEI </label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('imei')}>
                                    <input className="form-control"
                                           id="imei"
                                           name="imei"
                                           type="text"
                                           data-vlength={"1,15"}
                                           onBlur={this.validateField}
                                           value={additionalInformation.imei || ""}
                                           onChange={(e) => this.onChange(e)}/>
                                    {this.validateMessage("imei") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"imei"} delay={0}>
                                            {this.validateMessage("imei")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.invoiceTypeCode !== 'SARJ' && this.props.invoiceTypeCode !== 'SARJANLIK' &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">MAC </label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('mac')}>
                                    <input className="form-control"
                                           id="mac"
                                           name="mac"
                                           type="text"
                                           data-vlength={"1,17"}
                                           onBlur={this.validateField}
                                           value={additionalInformation.mac || ""}
                                           onChange={(e) => this.onChange(e)}/>
                                    {this.validateMessage("mac") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"mac"} delay={0}>
                                            {this.validateMessage("mac")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }
                    {(this.props.invoiceTypeCode === "SARJ" || this.props.invoiceTypeCode === "SARJANLIK") &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">Arac Kimlik No </label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('aracKimlikNo')}>
                                    <input className="form-control"
                                           id="aracKimlikNo"
                                           name="aracKimlikNo"
                                           type="text"
                                           data-vlength={"1,255"}
                                           onBlur={this.validateField}
                                           value={additionalInformation.aracKimlikNo || ""}
                                           onChange={(e) => this.onChange(e)}/>
                                    {this.validateMessage("aracKimlikNo") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"aracKimlikNo"} delay={0}>
                                            {this.validateMessage("aracKimlikNo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }
                    {(this.props.invoiceTypeCode === "SARJ" || this.props.invoiceTypeCode === "SARJANLIK") &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">Plaka No </label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('plakaNo')}>
                                    <input className="form-control"
                                           id="plakaNo"
                                           name="plakaNo"
                                           type="text"
                                           data-vlength={"1,17"}
                                           onBlur={this.validateField}
                                           value={additionalInformation.plakaNo || ""}
                                           onChange={(e) => this.onChange(e)}/>
                                    {this.validateMessage("plakaNo") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"plakaNo"} delay={0}>
                                            {this.validateMessage("plakaNo")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }

                    {(this.props.invoiceTypeCode === "SARJ") &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">ESURaporID</label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('esuRaporId')}>
                                    <input className="form-control"
                                           id="esuRaporId"
                                           name="esuRaporId"
                                           type="text"
                                           data-vlength={"1,255"}
                                           onBlur={this.validateField}
                                           value={additionalInformation.esuRaporId || ""}
                                           onChange={(e) => this.onChange(e)}/>
                                    {this.validateMessage("esuRaporId") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"esuRaporId"} delay={0}>
                                            {this.validateMessage("esuRaporId")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }

                    {["TEMELFATURA", "EARSIVFATURA", "KAMU", "IHRACAT", "HKS", "YOLCUBERABERFATURA", "TICARIFATURA", "ENERJI"].includes(this.props.profileId) &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">Son Ödeme Tarihi </label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('paymentDueDate')}>
                                    <Datetime locale="tr"
                                              className="datepicker"
                                              input={true}
                                              inputProps={{id: "paymentDueDate"}}
                                              onBlur={(momentObj) => this.validateField({
                                                  target: {
                                                      id: "paymentDueDate",
                                                      dataset: {
                                                          'vdata': "datetime"
                                                      },
                                                      value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                                  }
                                              })}
                                              closeOnSelect={true}
                                              value={moment(additionalInformation.paymentDueDate, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(additionalInformation.paymentDueDate, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                                  moment(additionalInformation.paymentDueDate).format("DD-MM-YYYY HH:mm:ss") :
                                                  additionalInformation.paymentDueDate}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat="HH:mm:ss"
                                              onChange={(momentObj) => this.onChange({
                                                  target: {
                                                      name: 'paymentDueDate',
                                                      value: (!(typeof momentObj === "string") ?  momentObj.format("YYYY-MM-DDTHH:mm:ss") : (moment(momentObj, "DD-MM-YYYY", true).isValid() ? moment(momentObj, "DD-MM-YYYY", true).format("YYYY-MM-DDTHH:mm:ss") : additionalInformation.paymentDueDate))
                                                  }
                                              })}/>
                                    {this.validateMessage("paymentDueDate") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"paymentDueDate"} delay={0}>
                                            {this.validateMessage("paymentDueDate")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }

                    {(this.props.invoiceTypeCode === "SARJ") &&
                        <div className="col-sm-6 row">
                            <label className="col-md-4 col-form-label">ESURaporID Oluşturulma Zamanı </label>
                            <div className="col-md-8">
                                <div className={"form-group" + this.validateClass('esuRaporIdIssueDate')}>
                                    <Datetime locale="tr"
                                              className="datepicker"
                                              input={true}
                                              inputProps={{id: "esuRaporIdIssueDate"}}
                                              onBlur={(momentObj) => this.validateField({
                                                  target: {
                                                      id: "esuRaporIdIssueDate",
                                                      dataset: {
                                                          'vdata': "date",
                                                          'vlength': (additionalInformation.esuRaporId ? "1,20" : "0,20")
                                                      },
                                                      value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                  }
                                              })}
                                              closeOnSelect={true}
                                              value={moment(additionalInformation.esuRaporIdIssueDate, "YYYY-MM-DD", true).isValid() ? moment(additionalInformation.esuRaporIdIssueDate).format("DD-MM-YYYY") : additionalInformation.esuRaporIdIssueDate}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              isValidDate={function (current) {
                                                  return current.isBefore(Datetime.moment());
                                              }}
                                              onChange={(momentObj) => this.onChange({
                                                  target: {
                                                      name: 'esuRaporIdIssueDate',
                                                      value: (!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)
                                                  }
                                              })}/>
                                    {this.validateMessage("esuRaporIdIssueDate") !== "" &&
                                        <UncontrolledTooltip placement="right" target={"esuRaporIdIssueDate"} delay={0}>
                                            {this.validateMessage("esuRaporIdIssueDate")}
                                        </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }

}

export default AdditionalInformation;